import { render, staticRenderFns } from "./appearance.vue?vue&type=template&id=1d28757a&scoped=true&"
import script from "./appearance.vue?vue&type=script&lang=ts&"
export * from "./appearance.vue?vue&type=script&lang=ts&"
import style0 from "./appearance.vue?vue&type=style&index=0&id=1d28757a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d28757a",
  null
  
)

export default component.exports